import { render, staticRenderFns } from "./BlockText.vue?vue&type=template&id=50c32309"
import script from "./BlockText.vue?vue&type=script&lang=js"
export * from "./BlockText.vue?vue&type=script&lang=js"
import style0 from "./BlockText.vue?vue&type=style&index=0&id=50c32309&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports